import { css } from '@emotion/react';
import { useTheme } from '@mui/material';
import Colors from '../theme/colors';

const useLoginFooterStyles = () => {
  const theme = useTheme();
  return {
    footerLinks: css({
      [theme.breakpoints.up('md')]: {
        whiteSpace: 'nowrap',
        border: '2px solid transparent',
        '&:hover': {
          fontWeight: 'bold',
        },
      },
    }),
    loginFooterContainer: css({
      backgroundColor: Colors.blue,
      padding: theme.spacing(0, 7, 0, 9),
      paddingLeft: '24px',
      fontSize: 14,
      position: 'relative',
      color: Colors.white,
      [theme.breakpoints.up('lg')]: {
        height: '228px',
      },
      '& > .MuiGrid-item': {
        padding: '13px 0',
        [theme.breakpoints.up('md')]: {
          padding: '14px 32px 13px 0',
        },
        '&:first-of-type': {
          padding: '14px 35px 5px 0',
          [theme.breakpoints.up('md')]: {
            padding: '14px 35px 32px 0',
          },
        },
        lineHeight: '16.41px',
        '&:last-child': {
          alignItems: 'flex-start',
          padding: '45px 0 31px 0',
          fontWeight: 600,
          [theme.breakpoints.up('md')]: {
            margin: '0 0 0 auto',
            textAlign: 'right',
            padding: '12px 0 13px 0',
            alignItems: 'center',
            fontWeight: 400,
          },
          '& .MuiGrid-item': {
            padding: '10px 0 0 0',
            fontWeight: 400,
            [theme.breakpoints.up('md')]: {
              padding: '0',
            },
          },
        },
      },
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    }),
    logoContainer: css({
      '& .MuiGrid-item': {
        fontSize: '11px',
        '&:nth-of-type(2)': {
          padding: '17px 0 0 0',
        },
      },
    }),
  };
};

export default useLoginFooterStyles;
